import { render } from "./RadioInput.vue?vue&type=template&id=cf0b6b3e&scoped=true"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"

import "./RadioInput.vue?vue&type=style&index=0&id=cf0b6b3e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf0b6b3e"]])

export default __exports__